import { Component, OnInit, AfterViewInit, Input } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import { ApiServiceClient } from "../../core/services/client.service";
import { switchMap } from "rxjs/operators";

@Component({
  selector: "request-open-finance-dialog",
  templateUrl: "request-open-finance-dialog.html",
  styleUrls: ["./request-open-finance-dialog.scss"]
})
export class RequestOpenFinanceDialog implements OnInit {
  @Input() email: string;
  @Input() idClient: string;
  @Input() idItem: string;

  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<RequestOpenFinanceDialog>,
    private apiServiceClient: ApiServiceClient,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    if (!this.email) {
      this.alert("O cliente precisa possuir email", "warning");
      this.dialogRef.close();
    }
  }

  sendEmailOpenFinance() {
    this.apiServiceClient.sendEmailOpenFinance(this.idClient).subscribe({
      next: () => {
        this.spinner.hide();
        this.router.navigate([`/open-finance-list`]);
        this.alert("salvo com sucesso", "success");
      },
      error: error => {
        this.alert("Ocorreu um erro", "error");
        this.spinner.hide();
        throw Error(error.message);
      }
    });
  }

  requestWithIdClient() {
    let data = {
      client_uuid: this.idClient,
      item_uuid: this.idItem
    };

    this.apiServiceClient.openFinanceUpdate(data).subscribe({
      next: () => {
        this.spinner.hide();
        this.router.navigate([`/open-finance-list`]);
        this.alert("salvo com sucesso", "success");
      },
      error: error => {
        this.alert("Ocorreu um erro", "error");
        this.spinner.hide();
        throw Error(error.message);
      }
    });
  }

  createRequest() {
    if (this.idItem) {
      return this.requestWithIdClient();
    }
    return this.sendEmailOpenFinance();
  }

  alert(title: string, icon: any) {
    Swal.fire({
      type: icon,
      title: title,
      showConfirmButton: false,
      timer: 1500
    });
  }
}
